import { useEffect, useCallback } from 'react';

import { ModalHeader } from 'App/Modals/templates/Default/components/ModalHeader';
import { Button } from 'UI/Forms/Button';

import { BUTTON_SIZE } from '../constants';
import { trackShow, trackGenerateLinkPopupDismissed } from '../../biEvents';
import { ShareMoreText } from '../ShareMoreText';

type PropsT = {
  availableGiftTotal: number;
  goToMainView: () => void;
  isPending: boolean;
  onGenerate: () => void;
  ariaDialogLabelId: string;
};

export const GenerateLinkModal: React.FunctionComponent<PropsT> = ({
  availableGiftTotal,
  goToMainView,
  isPending,
  onGenerate,
  ariaDialogLabelId,
}) => {
  const handleClose = useCallback(() => {
    goToMainView();
    trackGenerateLinkPopupDismissed('available', availableGiftTotal);
  }, [goToMainView, availableGiftTotal]);

  useEffect(() => {
    trackShow(availableGiftTotal);
  }, [availableGiftTotal]);

  return (
    <>
      <ModalHeader
        ariaDialogLabelId={ariaDialogLabelId}
        closeLabel="Back"
        title="Gift Article"
        variant="action"
        onClose={handleClose}
      />

      <div className="mb-24 flex grow flex-col justify-between">
        <div className="pt-18 md:pt-16">
          <p>Share this article with whomever you like.</p>

          <p>
            <ShareMoreText availableGiftTotal={availableGiftTotal} />
          </p>
        </div>

        <Button
          wide
          dataTestId="generate-share-link"
          pending={isPending}
          size={BUTTON_SIZE}
          variant="black"
          onClick={onGenerate}
        >
          Generate Share Link
        </Button>
      </div>
    </>
  );
};
